<template>
  <div class="frame-outer-wrap">
    <el-form :model="searchParams" label-width="120px" class="search-form">
      <el-row>
        <el-col :span="8">
          <el-form-item label="请选择厂牌">
            <el-select
              class="form-field"
              v-model="searchParams.companyId"
              placeholder="请选择厂牌"
              @change="fetchUrl"
              :clearable="true"
            >
              <el-option
                v-for="{id, name} of companyList"
                :key="id"
                :label="name"
                :value="id"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <iframe :src="url" class="frame-wrap" />
  </div>
</template>
<script>
import dataService from '@/api/data'

const host = (process.env.NODE_ENV === 'production' && location.hostname === 'tmecp.tencentmusic.com') ? 'cp.tencentmusic.com' : 'icas-tiger.tencentmusic.com'
export default {
  name: 'IncomeBaseFrame',
  props: {
    page: {
      type: String,
      default: 'contract'
    }
  },
  data() {
    return {
      url: '',
      searchParams: {
        companyId: ''
      },
      companyList: []
    }
  },
  created() {
    this.fetchCompanyList().then(() => {
      return this.fetchUrl()
    })
  },
  methods: {
    fetchCompanyList() {
      return dataService.getCompanyList().then(res => {
        this.companyList = res.list
        this.searchParams.companyId = (res.list[0] || {}).id
      }).catch(error => {
        this.$message.error('获取厂牌数据异常：' + error.message)
      })
    },
    fetchUrl() {
      const params = {
        ...this.searchParams
      }
      return dataService.getIncomeUrlParams(params).then(data => {
        this.url = `https://${host}/${this.page}/overview?${data}`
      }).catch(error => {
        this.$message.error(`获取链接参数异常: ${error.message}`)
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.frame-outer-wrap {
  display: flex;
  flex-direction: column;
  height: calc(100% - 50px);
  background: #fff;

  .search-form {
    padding: 15px 0 5px;

    .form-field {
      width: 95%;
    }
  }

  .frame-wrap {
    flex: 1;
    padding: 0;
    border: 0;
    margin: 0;
    width: 100%;
  }
}
</style>
